import useSWR, { type SWRConfiguration } from 'swr';
import { APPROVAL_V2_URL } from '@/constant/approval';
import type { ApprovalDetailResponse } from '@/types/approval';
import { getNestedDataFetcher } from '@/utils/apis';

/**
 * 품의 단건 조회.
 * - GET /api/v2/approval/{documentId}
 * - 편집 모드 진입 시 라우트 페이지에서 호출하여 ApprovalCreate 에 initialFormState 로 전달.
 * - documentId 없으면 호출 skip (SWR key null).
 */
const useApproval = (
  documentId?: string | null,
  config?: SWRConfiguration<ApprovalDetailResponse>,
) => {
  const { data, error, isLoading, isValidating, mutate } =
    useSWR<ApprovalDetailResponse>(
      documentId ? `${APPROVAL_V2_URL}/${documentId}` : null,
      getNestedDataFetcher,
      config,
    );

  return { data, error, isLoading, isValidating, mutate };
};

export default useApproval;
